import { AxiosResponse } from 'axios';
import { API_PATH } from 'common/constants/services';
import constate from 'constate';
import useLazyQuery from 'hook/useLazyQuery';
import usePartsQuery from 'hook/usePartsQuery';
import { useMemo, useState, useEffect } from 'react';

const [ChallengeContextProvider, useChallengeContextContext] = constate(() => {
  const [challengeId, setChallengeId] = useState(0);
  const partQuery = usePartsQuery();
  const [workoutsAutoComplete, setWorkoutsAutoComplete] = useState<Workout[]>(
    [],
  );
  const [challengeById, setChallengeById] = useState<IChallengeById | null>(
    null,
  );
  const [fetchedWorkout, setFetchedWorkout] = useState(false);
  const workoutsQuery = useLazyQuery<WorkoutResponse>(API_PATH.WORKOUTS, {
    param: {
      limit: 1000,
    },
    onSuccess: (res: AxiosResponse<WorkoutResponse, any>) => {
      setWorkoutsAutoComplete(res.data.results);
    },
  });

  const setWorkoutAndConditions = (challengeId: number) => {
    if (fetchedWorkout) {
      return;
    }

    setChallengeId(challengeId);
    workoutsQuery.refetch();
    setFetchedWorkout(true);
  };

  const conditions: IChallengeConditions[] = useMemo(() => {
    return challengeById ? challengeById.challenge_conditions : [];
  }, [challengeById]);

  const totalDate: number = useMemo(() => {
    return challengeById ? challengeById.total_date : 0;
  }, [challengeById]);

  const refetchWorkout = () => workoutsQuery.refetch();

  useEffect(() => {
    if (workoutsAutoComplete.length === 0) {
      workoutsQuery.refetch();
    }
  }, [workoutsAutoComplete, workoutsQuery]);

  return {
    conditions,
    challengeId,
    challengeById,
    setChallengeById,
    setWorkoutAndConditions,
    workoutsAutoComplete,
    totalDate,
    refetchWorkout,
    partQuery,
  };
});

export { ChallengeContextProvider, useChallengeContextContext };
